import { IAutomationAppComponent } from "../../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { ListPanel } from "./ListPanel";
import { MdTimeline } from "react-icons/md";
import {SideviewPanel} from "./SideviewPanel";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: MdTimeline,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ListPanel: ListPanel,
    SideViewPanel: SideviewPanel,
    isSmartApp: true,
    createConfig:  {
        group: 'Logics',
        name: "Cooling outlet pump request",
        description: "Cooling outlet pump request",
        panel: OverviewPanel,
        defaultState: { release: true },
    },

}